import React from 'react'
import data from '../data/AboutAsrit.json';
class DetailTextBox extends React.Component {

    render() {
        return (
            <div className="title-column col-lg-6 col-md-12 col-sm-12">
                <div className="inner-column">
                    <div className="sec-title">
                        <div className="sec-icons">
                            <span className="icon-one"></span>
                            <span className="icon-two"></span>
                            <span className="icon-three"></span>
                        </div>
                        <h2>{data.about.aboutus}</h2>
                    </div>
                    <div className="text">{data.about.desc1}</div>
                </div>
            </div>
        )
    }
}
export default DetailTextBox